/**
 * Peties Home — Interactive behaviors
 * - Sticky header hide/show on scroll
 * - FAQ accordion
 * - Mobile nav drawer
 * - Footer mobile collapsibles
 */

(function () {
  'use strict';

  /* === Sticky Header: hide on scroll-down, show on scroll-up === */
  const header = document.querySelector('[data-peties-header]');
  if (header) {
    let lastScrollY = 0;
    let ticking = false;

    function updateHeader() {
      const currentY = window.scrollY;
      if (currentY > 100 && currentY > lastScrollY) {
        header.classList.add('peties-header--hidden');
      } else {
        header.classList.remove('peties-header--hidden');
      }
      lastScrollY = currentY;
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(updateHeader);
        ticking = true;
      }
    }, { passive: true });
  }

  /* === Mobile Nav Drawer === */
  const menuOpen = document.querySelector('[data-peties-menu-open]');
  const menuClose = document.querySelector('[data-peties-menu-close]');
  const mobileNav = document.querySelector('[data-peties-mobile-nav]');

  if (menuOpen && mobileNav) {
    menuOpen.addEventListener('click', function () {
      mobileNav.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });
  }

  if (menuClose && mobileNav) {
    menuClose.addEventListener('click', function () {
      mobileNav.classList.remove('is-open');
      document.body.style.overflow = '';
    });
  }

  /* === FAQ Accordion === */
  const faqItems = document.querySelectorAll('[data-peties-faq-item]');
  faqItems.forEach(function (item) {
    const toggle = item.querySelector('[data-peties-faq-toggle]');
    if (!toggle) return;

    toggle.addEventListener('click', function () {
      const isOpen = item.classList.contains('is-open');

      // Close all other items
      faqItems.forEach(function (otherItem) {
        otherItem.classList.remove('is-open');
        const btn = otherItem.querySelector('[data-peties-faq-toggle]');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      });

      // Toggle current
      if (!isOpen) {
        item.classList.add('is-open');
        toggle.setAttribute('aria-expanded', 'true');
      }
    });
  });

  /* === Footer Mobile Collapsibles === */
  const footerCols = document.querySelectorAll('[data-peties-footer-col]');
  footerCols.forEach(function (col) {
    const heading = col.querySelector('[data-peties-footer-toggle]');
    if (!heading) return;

    heading.addEventListener('click', function () {
      // Only toggle on mobile
      if (window.innerWidth > 749) return;
      col.classList.toggle('is-open');
    });
  });

  /* === Cart count badge === */
  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var badge = document.querySelector('[data-cart-count]');
        if (badge) {
          if (cart.item_count > 0) {
            badge.textContent = cart.item_count;
            badge.style.display = 'flex';
          } else {
            badge.style.display = 'none';
          }
        }
      })
      .catch(function () {});
  }
  updateCartCount();
})();
